"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Button_1 = __importDefault(require("./atoms/Button"));
const gatsby_1 = require("gatsby");
const applyImg = require('../../../img/demo-apply.svg');
exports.default = (props) => (React.createElement(React.Fragment, null,
    React.createElement("h4", null, "the end of boilerplate."),
    React.createElement("p", null,
        "bake structure, opinions, and rules into projects. it's similar to the popular",
        ' ',
        React.createElement("a", { href: 'https://yeoman.io/', target: '_blank' }, "yeoman"),
        ' ',
        "package, but manages projects programmatically versus using boilerplate. counsel is for project maintainers. counsel makes sense for people who are developing many projects. counsel doesn't always make sense for teams or maintainers working on just a single project or two."),
    React.createElement("div", { style: { width: '100%', textAlign: 'center' } },
        React.createElement("img", { style: { padding: '1em' }, alt: 'demo', src: applyImg }),
        React.createElement(gatsby_1.Link, { to: '/docs/' },
            React.createElement(Button_1.default, null, "Get Started")))));
//# sourceMappingURL=Home.js.map